import { Component, OnInit, Self } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CaslAction } from "app/server/enums/casl-action.enum";
import { EntityTyp } from "app/util/enums/entity-typ.enum";
import { EntityModalComponent } from "../../../util/components/modal/entity-modal.component";
import { EmployeeDto, NameDto } from "app/api/models";
import { EmployeeFormGroupService } from "../employee-form-group.service";
import { AuthService } from "../../../util/service/auth.service";
import { UserRole } from "app/server/enums/user-role.enum";

@Component({
    selector: "app-employee-modal",
    templateUrl: "./employee-modal.component.html",
    styleUrl: "./employee-modal.component.scss",
    providers: [EmployeeFormGroupService],
    standalone: false
})
export class EmployeeModalComponent extends EntityModalComponent<EmployeeDto> implements OnInit {
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;
  protected readonly UserRole = UserRole;

  offices!: NameDto[];

  constructor(
    @Self() public formGroupService: EmployeeFormGroupService,
    public modal: NgbActiveModal,
    public authService: AuthService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.offices = this.data["offices"];

    super.ngOnInit();

    if (!this.formGroup.get("officeIds").value?.length && this.offices.length === 1) {
      this.formGroup.get("officeIds").setValue([this.offices[0].id]);
    }
  }
}
